// loadUrlQueryRoute.js
'use strict';
import { replace } from '../action/navigationAction.js';

// Spec: https://docs.google.com/document/d/1-XW_GPLpgp0QsKHtOTMjmGr_IXXvJXWmRB0eRb_YQZE

/**
 * Load url query route
 * @kind action
 * @param {URLSearchParams} {searchParams} - search params containing view id.
 * @return {Promise} Action promise.
 */
const loadUrlQueryRoute =
  ({ searchParams }) =>
  async dispatch => {
    const view = searchParams.get('view');
    let route = window.location.pathname;
    switch (view) {
      case 'chatlist':
        route = '/chat';
        break;
      case 'chat-user': {
        const userId = searchParams.get('user-id');
        if (userId) {
          route = `/chat/user/${userId}`;
        } else {
          route = `/chat/user/u/${searchParams.get('user-name')}`;
        }
        break;
      }
      case 'chat':
        route = `/chat/${searchParams.get('chatroom-id')}`;
        break;
      default:
        break;
    }
    const currentRoute = window.location.pathname;
    if (route !== currentRoute) {
      return dispatch(replace(route));
    } else {
      return { type: '' };
    }
  };

export default loadUrlQueryRoute;
